"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _index2 = _interopRequireDefault(require("@/components/Tinymce/index"));

var _store = require("@/api/store");

var _marketing = require("@/api/marketing");

var _logistics = require("@/api/logistics");

var _systemGroup = require("@/api/systemGroup");

var _ZBKJIutil = require("@/utils/ZBKJIutil");

var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/logistics/shippingTemplates/creatTemplates"));

var _index3 = _interopRequireDefault(require("../../appSetting/wxAccount/wxTemplate/index"));

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  storeName: '',
  storeInfo: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = {
  name: 'ProductProductAdd',
  components: {
    Templates: _index3.default,
    CreatTemplates: _creatTemplates.default,
    Tinymce: _index2.default
  },
  data: function data() {
    return {
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      activity: {
        '默认': 'red',
        '秒杀': 'blue',
        '砍价': 'green',
        '拼团': 'yellow'
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      checkboxGroup: [],
      recommend: [],
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      ruleList: [],
      merCateList: [],
      // 商户分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tempData: {
        page: 1,
        limit: 9999
      },
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: 0,
      isChoice: '',
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        storeName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        cateIds: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        keyword: [{
          required: true,
          message: '请输入商品关键字',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        storeInfo: [{
          required: true,
          message: '请输入商品简介',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }]
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isAttr: false,
      showAll: false,
      videoLink: ""
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj.attrValue[0])];
      delete obj[0].barCode;
      return obj;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        if (this.formValidate.specType && this.isAttr) this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);

    if (this.$route.params.id && this.formValidate.specType) {
      this.$watch('formValidate.attr', this.watCh);
    }
  },
  mounted: function mounted() {
    this.formValidate.sliderImages = [];

    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
    }

    this.getCategorySelect();
    this.getShippingList();
    this.getGoodsType();
  },
  methods: {
    keyupEvent: function keyupEvent(e, array, index, row, num) {
      e.target.value = e.target.value.replace(/[^\d.]/g, '');
      e.target.value = e.target.value.replace(/\.{2,}/g, '.');
      e.target.value = e.target.value.replace(/^\./g, '0.');
      e.target.value = e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0, e.target.value.length - 1));
      e.target.value = e.target.value.replace(/^0[^\.]+/g, '0');
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2');

      switch (num) {
        case 1:
          if (row == 'stock') {
            this.oneFormBatch[index][row] = parseInt(e.target.value);
          } else {
            this.oneFormBatch[index][row] = e.target.value;
          }

          break;

        case 2:
          if (row == 'stock') {
            this.OneattrValue[index][row] = parseInt(e.target.value);
          } else {
            this.OneattrValue[index][row] = e.target.value;
          }

          break;

        default:
          if (row == 'stock') {
            this.ManyAttrValue[index][row] = parseInt(e.target.value);
          } else {
            this.ManyAttrValue[index][row] = e.target.value;
          }

          break;
      }
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.isAttr = true;
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;

      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    onChangeGroup: function onChangeGroup() {
      this.checkboxGroup.includes('isGood') ? this.formValidate.isGood = true : this.formValidate.isGood = false;
      this.checkboxGroup.includes('isBenefit') ? this.formValidate.isBenefit = true : this.formValidate.isBenefit = false;
      this.checkboxGroup.includes('isBest') ? this.formValidate.isBest = true : this.formValidate.isBest = false;
      this.checkboxGroup.includes('isNew') ? this.formValidate.isNew = true : this.formValidate.isNew = false;
      this.checkboxGroup.includes('isHot') ? this.formValidate.isHot = true : this.formValidate.isHot = false;
    },
    watCh: function watCh(val) {
      var _this2 = this;

      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this2.attrInfo[key]) _this2.ManyAttrValue[index] = _this2.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this2.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);

      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);

                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });

                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }

                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              }; // Object.values(res[kk].attrValue).forEach((v, i) => {
              //   res[kk]['value' + i] = v
              // })

              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }

        return res;
      }
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 添加规则；
    addRule: function addRule() {
      var _this = this;

      this.$modalAttr(this.formDynamics, function () {
        _this.productGetRule();
      });
    },
    // 选择规格
    onChangeSpec: function onChangeSpec(num) {
      this.isAttr = true;
      if (num) this.productGetRule();
    },
    // 选择属性确认
    confirm: function confirm() {
      var _this3 = this;

      this.isAttr = true;

      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }

      var data = [];
      this.ruleList.forEach(function (item) {
        if (item.id === _this3.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            data.push({
              attrName: i.value,
              attrValue: i.detail
            });
          });
        }

        _this3.formValidate.attr = data;
      });
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this4 = this;

      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this4.merCateList = _this4.filerMerCateList(res);
        var newArr = [];
        res.forEach(function (value, index) {
          newArr[index] = value;
          if (value.child) newArr[index].child = value.child.filter(function (item) {
            return item.status === true;
          });
        }); //过滤商品分类设置为隐藏的子分类不出现在树形列表里

        _this4.merCateList = _this4.filerMerCateList(newArr);
      });
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }

        item.label = item.name;
        return item;
      });
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this5 = this;

      (0, _store.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;

        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }

        _this5.ruleList = list;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this6 = this;

      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this6.shippingList = res.list;
      });
    },
    showInput: function showInput(item) {
      this.$set(item, 'inputVisible', true);
    },
    onChangetype: function onChangetype(item) {
      var _this7 = this;

      if (item === 1) {
        this.OneattrValue.map(function (item) {
          _this7.$set(item, 'brokerage', null);

          _this7.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          _this7.$set(item, 'brokerage', null);

          _this7.$set(item, 'brokerageTwo', null);
        });
      } else {
        this.OneattrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;

          _this7.$set(item, 'brokerage', null);

          _this7.$set(item, 'brokerageTwo', null);
        });
        this.ManyAttrValue.map(function (item) {
          delete item.brokerage;
          delete item.brokerageTwo;
        });
      }
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(index) {
      this.ManyAttrValue.splice(index, 1);
    },
    // 批量添加
    batchAdd: function batchAdd() {
      // if (!this.oneFormBatch[0].pic || !this.oneFormBatch[0].price || !this.oneFormBatch[0].cost || !this.oneFormBatch[0].ot_price ||
      //     !this.oneFormBatch[0].stock || !this.oneFormBatch[0].bar_code) return this.$Message.warning('请填写完整的批量设置内容！');
      var _iterator = _createForOfIteratorHelper(this.ManyAttrValue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          this.$set(val, 'image', this.oneFormBatch[0].image);
          this.$set(val, 'price', this.oneFormBatch[0].price);
          this.$set(val, 'cost', this.oneFormBatch[0].cost);
          this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
          this.$set(val, 'stock', this.oneFormBatch[0].stock);
          this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
          this.$set(val, 'weight', this.oneFormBatch[0].weight);
          this.$set(val, 'volume', this.oneFormBatch[0].volume);
          this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
          this.$set(val, 'brokerageTwo', this.oneFormBatch[0].brokerageTwo);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // 添加按钮
    addBtn: function addBtn() {
      this.clearAttr();
      this.isBtn = true;
    },
    // 取消
    offAttrName: function offAttrName() {
      this.isBtn = false;
    },
    clearAttr: function clearAttr() {
      this.isAttr = true;
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveAttr: function handleRemoveAttr(index) {
      this.isAttr = true;
      this.formValidate.attr.splice(index, 1);
      this.manyFormValidate.splice(index, 1);
    },
    // 删除属性
    handleClose: function handleClose(item, index) {
      item.splice(index, 1);
    },
    // 添加规则名称
    createAttrName: function createAttrName() {
      this.isAttr = true;

      if (this.formDynamic.attrsName && this.formDynamic.attrsVal) {
        var data = {
          attrName: this.formDynamic.attrsName,
          attrValue: [this.formDynamic.attrsVal]
        };
        this.formValidate.attr.push(data);
        var hash = {};
        this.formValidate.attr = this.formValidate.attr.reduce(function (item, next) {
          /* eslint-disable */
          hash[next.attrName] ? '' : hash[next.attrName] = true && item.push(next);
          return item;
        }, []);
        this.clearAttr();
        this.isBtn = false;
      } else {
        this.$Message.warning('请添加完整的规格！');
      }
    },
    // 添加属性
    createAttr: function createAttr(num, idx) {
      this.isAttr = true;

      if (num) {
        this.formValidate.attr[idx].attrValue.push(num);
        var hash = {};
        this.formValidate.attr[idx].attrValue = this.formValidate.attr[idx].attrValue.reduce(function (item, next) {
          /* eslint-disable */
          hash[next] ? '' : hash[next] = true && item.push(next);
          return item;
        }, []);
        this.formValidate.attr[idx].inputVisible = false;
      } else {
        this.$message.warning('请添加属性');
      }
    },
    //点击展示所有多规格属性
    showAllSku: function showAllSku() {
      if (this.isAttr == false) {
        this.isAttr = true;
        if (this.formValidate.specType && this.isAttr) this.watCh(this.formValidate.attr); //重要！！！
      } else if (this.isAttr == true) {
        this.isAttr = false;
        this.getInfo();
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this8 = this;

      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(this.$route.params.id).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var info, imgs, imgss, manyAttr, tmp, tmpTab;
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // this.isAttr = true;
                  info = res;
                  _this8.formValidate = {
                    image: _this8.$selfUtil.setDomain(info.image),
                    sliderImage: info.sliderImage,
                    sliderImages: JSON.parse(info.sliderImage),
                    storeName: info.storeName,
                    storeInfo: info.storeInfo,
                    keyword: info.keyword,
                    cateIds: info.cateId.split(','),
                    // 商品分类id
                    cateId: info.cateId,
                    // 商品分类id传值
                    unitName: info.unitName,
                    sort: info.sort,
                    isShow: info.isShow,
                    isBenefit: info.isBenefit,
                    isNew: info.isNew,
                    isGood: info.isGood,
                    isHot: info.isHot,
                    isBest: info.isBest,
                    tempId: info.tempId,
                    attr: info.attr,
                    attrValue: info.attrValue,
                    selectRule: info.selectRule,
                    isSub: info.isSub,
                    content: _this8.$selfUtil.replaceImgSrcHttps(info.content),
                    specType: info.specType,
                    id: info.id,
                    giveIntegral: info.giveIntegral,
                    ficti: info.ficti,
                    coupons: info.coupons,
                    couponIds: info.couponIds,
                    activity: info.activityStr ? info.activityStr.split(',') : ['默认', '秒杀', '砍价', '拼团']
                  };
                  (0, _marketing.marketingSendApi)({
                    type: 3
                  }).then(function (res) {
                    if (_this8.formValidate.couponIds !== null) {
                      var ids = _this8.formValidate.couponIds.toString();

                      var arr = res.list;
                      var obj = {};

                      for (var i in arr) {
                        obj[arr[i].id] = arr[i];
                      }

                      var strArr = ids.split(',');
                      var newArr = [];

                      var _iterator2 = _createForOfIteratorHelper(strArr),
                          _step2;

                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          var item = _step2.value;

                          if (obj[item]) {
                            newArr.push(obj[item]);
                          }
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }

                      _this8.$set(_this8.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,

                    }
                  });
                  imgs = JSON.parse(info.sliderImage);
                  imgss = [];
                  Object.keys(imgs).map(function (i) {
                    imgss.push(_this8.$selfUtil.setDomain(imgs[i]));
                  });
                  _this8.formValidate.sliderImages = [].concat(imgss);

                  if (_this8.getFileType(_this8.formValidate.sliderImages[0]) == 'video') {
                    //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
                    _this8.$set(_this8.formValidate, 'videoLink', _this8.formValidate.sliderImages[0]);

                    _this8.formValidate.sliderImages.splice(0, 1);
                  }

                  if (info.isHot) _this8.checkboxGroup.push('isHot');
                  if (info.isGood) _this8.checkboxGroup.push('isGood');
                  if (info.isBenefit) _this8.checkboxGroup.push('isBenefit');
                  if (info.isBest) _this8.checkboxGroup.push('isBest');
                  if (info.isNew) _this8.checkboxGroup.push('isNew');

                  _this8.productGetRule();

                  if (info.specType) {
                    _this8.formValidate.attr = info.attr.map(function (item) {
                      return {
                        attrName: item.attrName,
                        attrValue: item.attrValues.split(',')
                      };
                    });
                    _this8.ManyAttrValue = info.attrValue;

                    _this8.ManyAttrValue.forEach(function (val) {
                      val.image = _this8.$selfUtil.setDomain(val.image);
                      val.attrValue = JSON.parse(val.attrValue);
                      _this8.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
                    });
                    /***多规格商品如果被删除过sku，优先展示api返回的数据,否则会有没有删除的错觉***/


                    manyAttr = _this8.attrFormat(_this8.formValidate.attr);

                    if (manyAttr.length !== _this8.ManyAttrValue.length) {
                      _this8.$set(_this8, 'showAll', true);

                      _this8.isAttr = false;
                    } else {
                      _this8.isAttr = true;
                    }
                    /*******/


                    tmp = {};
                    tmpTab = {};

                    _this8.formValidate.attr.forEach(function (o, i) {
                      // tmp['value' + i] = { title: o.attrName }
                      // tmpTab['value' + i] = ''
                      tmp[o.attrName] = {
                        title: o.attrName
                      };
                      tmpTab[o.attrName] = '';
                    }); // 此处手动实现后台原本value0 value1的逻辑


                    _this8.formValidate.attrValue.forEach(function (item) {
                      for (var attrValueKey in item.attrValue) {
                        item[attrValueKey] = item.attrValue[attrValueKey];
                      }
                    });

                    _this8.manyTabTit = tmp;
                    _this8.manyTabDate = tmpTab;
                    _this8.formThead = Object.assign({}, _this8.formThead, tmp);
                  } else {
                    _this8.OneattrValue = info.attrValue; // this.formValidate.attr = [] //单规格商品规格设置为空
                  }

                  _this8.fullscreenLoading = false;

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this8.fullscreenLoading = false;

        _this8.$message.error(res.message);
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;

      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }

        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning("最多选择10张图片！");
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }

        if (tit === '3' && status == 'video') {
          var videoInfo = img[0];

          if (videoInfo.attType !== 'video/mp4') {
            this.$message.warning("请重新选择视频！");
          } else {
            _this.$set(_this.formValidate, 'videoLink', videoInfo.sattDir);
          }
        }

        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }

        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }

        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    handleSubmitUp: function handleSubmitUp() {
      // this.currentTab --
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    handleSubmitNest: function handleSubmitNest(name) {
      var _this9 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this9.currentTab++ > 2) _this9.currentTab = 0;
        } else {
          if (!_this9.formValidate.store_name || !_this9.formValidate.cate_id || !_this9.formValidate.keyword || !_this9.formValidate.unit_name || !_this9.formValidate.store_info || !_this9.formValidate.image || !_this9.formValidate.slider_image) {
            _this9.$message.warning("请填写完整商品信息！");
          }
        }
      });
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this10 = this;

      this.onChangeGroup();
      if (this.formValidate.specType && this.formValidate.attr.length < 1) return this.$message.warning("请填写多规格属性！");
      this.formValidate.cateId = this.formValidate.cateIds.join(',');

      if (this.formValidate.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.formValidate.videoLink);
      }

      this.formValidate.sliderImage = JSON.stringify(this.formValidate.sliderImages);

      if (this.formValidate.specType) {
        this.formValidate.attrValue = this.ManyAttrValue;
        this.formValidate.attr = this.formValidate.attr.map(function (item) {
          return {
            attrName: item.attrName,
            id: item.id,
            attrValues: item.attrValue.join(',')
          };
        });

        for (var i = 0; i < this.formValidate.attrValue.length; i++) {
          this.$set(this.formValidate.attrValue[i], 'id', 0);
          this.$set(this.formValidate.attrValue[i], 'productId', 0);
          this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.stringify(this.formValidate.attrValue[i].attrValue)); //

          delete this.formValidate.attrValue[i].value0;
        }
      } else {
        this.formValidate.attr = [{
          attrName: '规格',
          attrValues: '默认',
          id: this.$route.params.id ? this.formValidate.attr[0].id : 0
        }];
        this.OneattrValue.map(function (item) {
          _this10.$set(item, 'attrValue', JSON.stringify({
            '规格': '默认'
          }));
        });
        this.formValidate.attrValue = this.OneattrValue;
      }

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this10.fullscreenLoading = true;
          _this10.$route.params.id ? (0, _store.productUpdateApi)(_this10.formValidate).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
              return _index.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _this10.$message.success('编辑成功');

                      setTimeout(function () {
                        _this10.$router.push({
                          path: '/store/index'
                        });
                      }, 500);
                      _this10.fullscreenLoading = false;

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this10.fullscreenLoading = false;
          }) : (0, _store.productCreateApi)(_this10.formValidate).then( /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
              return _index.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _this10.$message.success('新增成功');

                      setTimeout(function () {
                        _this10.$router.push({
                          path: '/store/index'
                        });
                      }, 500);
                      _this10.fullscreenLoading = false;

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this10.fullscreenLoading = false;
          });
        } else {
          if (!_this10.formValidate.storeName || !_this10.formValidate.cateId || !_this10.formValidate.keyword || !_this10.formValidate.unitName || !_this10.formValidate.storeInfo || !_this10.formValidate.image || !_this10.formValidate.sliderImages) {
            _this10.$message.warning("请填写完整商品信息！");
          }
        }
      });
    }),
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';

        if (item === this.dragging) {
          return;
        }

        var newItems = _toConsumableArray(this.formValidate.sliderImages);

        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    },
    handleDragEnterFont: function handleDragEnterFont(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';

        if (item === this.dragging) {
          return;
        }

        var newItems = _toConsumableArray(this.formValidate.activity);

        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.activity = newItems;
      }
    },
    getGoodsType: function getGoodsType() {
      var _this11 = this;

      /** 让商品推荐列表的name属性与页面设置tab的name匹配**/
      (0, _systemGroup.goodDesignList)({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [],
            arr1 = [];
        var listArr = [{
          name: '是否热卖',
          value: 'isGood'
        }];
        var typeLists = [{
          name: '',
          value: 'isHot',
          type: '2'
        }, //热门榜单
        {
          name: '',
          value: 'isBenefit',
          type: '4'
        }, //促销单品
        {
          name: '',
          value: 'isBest',
          type: '1'
        }, //精品推荐
        {
          name: '',
          value: 'isNew',
          type: '3'
        }]; //首发新品

        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this11.recommend = listArr;
      });
    },
    // 删除视频；
    delVideo: function delVideo() {
      var that = this;
      that.$set(that.formValidate, "videoLink", "");
    },
    zh_uploadFile: function zh_uploadFile() {
      if (this.videoLink) {
        this.$set(this.formValidate, 'videoLink', this.videoLink);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = ''; // 获取类型结果

      var result = '';

      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      } // fileName无后缀返回 false


      if (!suffix) {
        return false;
      }

      suffix = suffix.toLocaleLowerCase(); // 图片格式

      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']; // 进行图片匹配

      result = imglist.find(function (item) {
        return item === suffix;
      });

      if (result) {
        return 'image';
      } // 匹配 视频


      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });

      if (result) {
        return 'video';
      } // 其他 文件类型


      return 'other';
    }
  }
};
exports.default = _default;